import React, { Component, PropTypes } from 'react';
import Tooltip from 'material-ui/internal/Tooltip';

import { isEmpty } from 'lodash';

import styled from 'styled-components';

const FilterItemContainer = styled.div`
  display: inline-block;
  margin-right: 6px;
  padding: 4px 12px;
  border-radius: 4px;
  background: ${props => props.theme.color.border};
  font-size: 12px;
  margin-bottom: 10px;
  &:last-child {
    margin-right: 0;
    ${'' /* margin-bottom: 0; */};
  }
`;

const FilterTitle = styled.span`
  margin-right: 6px;
  font-family: ${props => props.theme.font.bold};
`;

const FilterLabel = styled.span`
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  white-space: nowrap;
  vertical-align: bottom;

  @media (max-width: 1024px) {
    max-width: 100px;
  }
`;

const Tooltips = styled.ul`
  display: flex;
  flex-direction: row;
  max-width: 300px;
  margin-left: -40px;
  flex-wrap: wrap;
  li {
    flex: 1
    padding: 10px;
    margin: 10px;
    text-decoration: none;
    list-style: none;
  }
`;

class FilterItem extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      showTooltip: false
    };
  }

  toggleTooltipOn = () => {
    this.setState({
      showTooltip: true
    });
  };

  toggleTooltipOff = () => {
    this.setState({
      showTooltip: false
    });
  };

  render() {
    const { filter } = this.props;
    const { title, value } = filter;

    // Hide pill if value is empty
    if (!value) {
      return null;
    }

    if (typeof value === 'object' && isEmpty(value)) {
      return null;
    }

    const label = filter.label || filter.component.getLabel(filter);

    const tips = Array.isArray(label) ? label : label.split(',');
    const labelStr = Array.isArray(label) ? label.join(' , ') : label;
    const labelLists = (
      <Tooltips>{tips.map((li, idx) => <li key={idx}>{li}</li>)}</Tooltips>
    );

    return (
      <FilterItemContainer
        onMouseEnter={this.toggleTooltipOn}
        onMouseLeave={this.toggleTooltipOff}
      >
        <FilterTitle>{title}</FilterTitle>
        <FilterLabel>{labelStr}</FilterLabel>

        <Tooltip
          show={this.state.showTooltip}
          label={labelLists}
          style={{ fontSize: '9pt' }}
        />
      </FilterItemContainer>
    );
  }
}

FilterItem.propTypes = {
  filter: PropTypes.object.isRequired
};

export default FilterItem;



// WEBPACK FOOTER //
// ./src/components/filter/FilterItem.js